import { render, staticRenderFns } from "./AcademyParticipant.vue?vue&type=template&id=40023d3b&scoped=true"
import script from "./AcademyParticipant.vue?vue&type=script&lang=ts"
export * from "./AcademyParticipant.vue?vue&type=script&lang=ts"
import style0 from "./AcademyParticipant.vue?vue&type=style&index=0&id=40023d3b&prod&lang=css"
import style1 from "./AcademyParticipant.vue?vue&type=style&index=1&id=40023d3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40023d3b",
  null
  
)

export default component.exports